<template>
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <div v-if="!initializing" class="mb-4">
    <div>
      <template v-if="informacionAlojamiento?.imagenPrincipal?.url">
        <div
          class="blog_banner d-flex justify-content-center align-content-center pb-5"
          :style="{
            backgroundImage: 'url(' + informacionAlojamiento.imagenPrincipal.url + ')',
          }">
          <template v-if="fromBuscador && hotelSeleccionadoBuscador != null">
            <div class="d-none d-md-block">
              <BuscadorParaTi />
            </div>
            <div class="card buscador-ocultar shadow w-70 mx-3 d-block d-md-none">
              <div class="card-body text-primary position-relative pb-0">
                <HeaderBuscadorParaTi />
                <div class="m-1 text-end mb-3" style="right: 0; bottom: -17px">
                  <button
                    class="btn btn-primary rounded-circle me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#modalBuscadorParaTi">
                    <div class="d-flex">
                      <div class="">
                        <i class="fa-solid fa-magnifying-glass fa-sm" />
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-if="informacionAlojamiento?.imagenesSecundarias?.length > 0" class="carousel-imagenes">
          <div>
            <CarouselAlojamiento :lista-fotos="informacionAlojamiento.imagenesSecundarias.map(img => img.url)" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="blog_banner">
          <div v-if="informacionAlojamiento?.imagenesSecundarias?.length > 0" class="carousel-imagenes">
            <div>
              <CarouselAlojamiento :lista-fotos="informacionAlojamiento.imagenesSecundarias.map(img => img.url)" />
            </div>
          </div>
        </div>
      </template>
      <div>
        <div class="alojamiento-container px-3 mt-5 row">
          <div class="d-flex justify-content-between align-items-center flex-wrap">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start w-100">
              <h1 class="fw-bolder mb-0 h-100">{{ informacionAlojamiento.nombre }}</h1>
              <button type="button" class="btn btn-link p-0" data-bs-toggle="modal" data-bs-target="#modalFotos">
                {{ $t('alojamiento.verFoto') }}
              </button>
              <ModalFotos
                :informacion-alojamiento="informacionAlojamiento"
                :nombre-alojamiento="informacionAlojamiento.nombre" />
            </div>
          </div>
          <span class="text-muted mt-2 p-0">
            <button class="btn btn-link" data-bs-toggle="modal" data-bs-target="#mapaModalAlojamiento">
              <i class="fa-solid fa-location-pin" />
              {{ informacionAlojamiento.ubicacion }}
            </button>
          </span>
          <div style="display: inline-block" class="mt-0 mb-3">
            <template v-for="estrellas in informacionAlojamiento.estrellas" :key="estrellas">
              <i class="fa-regular fa-star" />
            </template>
          </div>
          <div class="mb-3 d-flex align-items-center botones-container">
            <button
              v-if="informacionAlojamiento?.servicios?.length > 0"
              class="ms-0 text-primary boton boton-blanco"
              @click="scrollToElement('servicios')">
              {{ $t('alojamiento.servicios') }}
            </button>
            <button v-if="fromBuscador" class="text-primary boton boton-blanco" @click="scrollToElement('ofertas')">
              {{ $t('alojamiento.ofertas') }}
            </button>
            <button
              v-if="informacionAlojamiento?.faqs?.length > 0"
              class="text-primary boton boton-blanco"
              @click="scrollToElement('preguntas')">
              {{ $t('alojamiento.preguntasFrecuentes') }}
            </button>
          </div>
          <div class="row text-container mt-3">
            <div class="col-6 ps-3 pe-4 left">
              <h6 class="fs-5 fw-semibold mb-3">
                {{ $t('alojamiento.horariosCondiciones') }}
              </h6>
              <div class="row d-flex flex-column flex-md-row my-3 card-check">
                <div v-if="informacionAlojamiento.checkIn" class="col-12 col-sm-6">
                  <div class="row">
                    <div class="col-3">
                      <i class="fa-solid fa-door-open fa-2x icon-checkin" />
                    </div>
                    <div class="col-9">
                      <p class="m-0 fw-bold">{{ $t('alojamiento.checkIn') }}</p>
                      <span>{{ informacionAlojamiento.checkIn }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="informacionAlojamiento.checkOut" class="col-12 col-sm-6">
                  <div class="row">
                    <div class="col-3">
                      <i class="fa-solid fa-door-open fa-2x" />
                    </div>
                    <div class="col-9">
                      <p class="m-0 fw-bold">{{ $t('alojamiento.checkOut') }}</p>
                      <span>{{ informacionAlojamiento.checkOut }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 ps-4 right">
              <h5 class="fs-5 fw-semibold">
                {{ $t('alojamiento.descripcionAlojamiento') }}
              </h5>
              <div class="translate">
                <div v-sanitize-html="formattedInfo" class="my-3 text-primary"></div>
              </div>
              <button
                v-if="informacionAlojamiento?.info?.length > 200"
                type="button"
                class="btn btn-link text-start p-0"
                @click="toggleMostrarMas">
                {{ mostrarMas ? $t('general.mostrarMenos') : $t('general.mostrarMas') }}
              </button>
            </div>
          </div>

          <template v-if="informacionAlojamiento?.servicios?.length > 0">
            <h4 id="servicios" class="fs-4and5 fw-bold mt-4 mb-3">
              {{ $t('alojamiento.servicioHotel') }}
            </h4>
            <div class="row d-flex mb-4 justify-content-start">
              <div
                v-for="(servicio, index) in informacionAlojamiento.servicios"
                :key="index"
                class="col-6 col-md-4 col-lg-3 col-xl-2 d-flex flex-column my-3">
                <div class="d-flex align-items-center gap-2">
                  <i class="fa-solid fa-check text-muted"></i>
                  <p class="mb-0 translate">
                    {{ capitalizeFirstLetter(servicio) }}
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template
            v-if="
              informacionAlojamiento?.accesosPistas?.length > 0 || informacionAlojamiento?.puntosinteres?.length > 0
            ">
            <h4 class="fs-4and5 fw-bold mt-4 mb-3">
              {{ $t('alojamiento.puntoInteres') }}
            </h4>
            <template
              v-if="
                informacionAlojamiento?.accesosPistas?.length > 0 || informacionAlojamiento?.puntosinteres?.length > 0
              ">
              <p v-for="(acceso, index) in informacionAlojamiento.accesosPistas" :key="index" class="text-muted fs-8">
                <i v-if="checkDomain([DOMAINS.pokerRed])" class="fas fa-thumbtack pushpin-icon icon-location"></i>
                <img v-else class="icono-distancia-estacion" src="@/assets/icons/icono-telesilla.webp" />
                {{ acceso.distancia >= 1 ? acceso.distancia + ' km' : acceso.distancia * 1000 + ' m' }}
                <span>{{ acceso.nombre }}</span>
                <br />
                <span class="ms-4">({{ titleCase(acceso.lugarExperiencia) }})</span>
              </p>

              <p v-for="(punto, index) in informacionAlojamiento.puntosinteres" :key="index" class="text-muted fs-8">
                <img class="icono-distancia-estacion" src="@/assets/icons/icono-punto-interes.webp" />
                {{ punto.distancia >= 1 ? punto.distancia + ' km' : punto.distancia * 1000 + ' m' }}
                <span>{{ punto.nombre }}</span>
              </p>
            </template>
          </template>
          <div v-if="fromBuscador && hotelSeleccionadoBuscador != null" id="ofertas" class="translate">
            <h6 class="fs-4and5 fw-bold my-3">
              {{ $t('alojamiento.regimenDisponibles') }} |
              <span class="fw-normal">
                {{ formatDateWithWeekDay(fechasAlojamiento[0]) }}
                -
                {{ formatDateWithWeekDay(fechasAlojamiento[1]) }}
              </span>
            </h6>
            <div class="d-flex gap-2 me-3 mt-4 flex-wrap">
              <div
                v-for="(lugaresExperiencia, pension) in hotelSeleccionadoBuscador.pensiones"
                :key="pension"
                class="boton-cuadro-azul translate"
                :class="hotelSeleccionadoBuscador.currentPension == pension ? 'boton-cuadro-azul-selected' : ''"
                @click="updateOpcionesPensionActual(pension)">
                {{ opcionesPension[pension] }}
              </div>
            </div>
            <template v-for="(lugaresExperiencia, pension) in hotelSeleccionadoBuscador.pensiones" :key="pension">
              <!-- Pension actual -->
              <template v-if="hotelSeleccionadoBuscador.currentPension == pension">
                <template v-for="(opciones, lugarExperiencia) in lugaresExperiencia" :key="lugarExperiencia">
                  <div
                    v-if="estacionSeleccionadaBuscador == lugarExperiencia"
                    class="d-flex flex-column cuadro-forfaits my-3 p-2 p-md-4">
                    <div class="d-flex flex-column flex-lg-row w-100 justify-content-between mb-3">
                      <div class="d-flex gap-2">
                        <div>
                          <img
                            class="img-lugarExperiencia"
                            :src="
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].imagen
                                : ''
                            "
                            alt="" />
                        </div>
                        <div class="texto-estacion">
                          <p class="mb-0 fw-bold">
                            {{
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].nombre
                                : ''
                            }}
                          </p>
                          <div
                            v-if="
                              agenciaStore.buscadorForfaitEnabled &&
                              hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                            "
                            class="d-flex align-items-start gap-1 ms-0">
                            <img class="icono-distancia-estacion" src="@/assets/icons/icono-telesilla.webp" />
                            <span class="texto-distancia-estacion">
                              {{ $t('general.a') }}
                              {{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .distanciaKM >= 1
                                  ? hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM + ' km'
                                  : hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM *
                                      1000 +
                                    ' m'
                              }}
                              {{ $t('alojamiento.deEstacionEsqui') }}({{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .nombreAccesoPista
                              }})
                            </span>
                          </div>
                        </div>
                      </div>

                      <template v-if="desplegarEstaciones[lugarExperiencia] !== undefined">
                        <!-- Icono up y down -->
                        <i
                          v-if="desplegarEstaciones[lugarExperiencia]"
                          class="cursor-pointer ms-5 me-3 fs-3 fa-solid fa-angle-up d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                        <i
                          v-else
                          class="cursor-pointer ms-5 me-3 fs-3 fa-solid fa-angle-down d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                      </template>
                    </div>
                    <template
                      v-if="
                        desplegarEstaciones[lugarExperiencia] !== undefined &&
                        desplegarEstaciones[lugarExperiencia] &&
                        numOpcionesMostrar[lugarExperiencia] !== undefined
                      ">
                      <div
                        v-for="(opcion, indOpcion) in opciones.slice(0, numOpcionesMostrar[lugarExperiencia])"
                        :key="indOpcion"
                        class="d-flex flex-column flex-md-row cuadro-opcion my-2 justify-content-between p-4">
                        <div class="d-flex flex-column gap-4 informacion-habitaciones">
                          <template v-for="(habitacion, indHab) in opcion.combinacion" :key="indHab">
                            <p class="fw-bold mb-0">
                              {{ $t('general.habitacion') }}
                              {{ titleCase(habitacion.texto) }}
                            </p>
                            <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                              <div class="ms-4 d-flex w-100 translate">
                                <div v-for="i in habitacion.precios.personas.numAdultos" :key="i" class="personas">
                                  <img src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                <div
                                  v-for="i in habitacion.precios.personas.numNinios"
                                  :key="i"
                                  class="personas d-flex">
                                  <img class="personitas" src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                {{ formatMiembrosHabitacion(habitacion.precios.personas) }}
                              </div>
                              <div class="d-flex flex-column text-start text-sm-end w-100">
                                <p v-if="habitacion.precios.personas.numAdultos > 0" class="m-0">
                                  {{ $t('general.personas.mayus.adulto') }}:
                                  <span class="fw-bold">
                                    {{ habitacion.precios.personas.precioAdulto }}{{ agenciaStore.getCurrency }}
                                  </span>
                                </p>
                                <p v-for="(n, i) in habitacion.precios.personas.ninios" :key="i" class="m-0">
                                  {{ $t('general.personas.mayus.nino') }}
                                  {{ n.edad }}
                                  {{ $t('general.anios') }}:
                                  <span class="fw-bold">{{ n.precio }}{{ agenciaStore.getCurrency }}</span>
                                </p>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="d-flex flex-column align-items-end justify-content-between">
                          <div
                            v-if="opcion.tipoCancelacion == 'TOTAL'"
                            class="texto-cancelacion-total fw-bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.cancelacionGratis') }}
                          </div>
                          <div
                            v-else-if="opcion.tipoCancelacion == 'PARCIAL'"
                            class="texto-cancelacion-parcial fw-bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.parcialmenteReembolsable') }}
                          </div>
                          <div v-else />
                          <div class="d-flex flex-column justify-content-end gap-2 alignt-items-center">
                            <p class="d-flex align-items-center gap-2 texto-desde-precio m-0 justify-content-end">
                              {{ $t('subtitulo.total') }}:
                              <span class="fs-5 fw-bold">
                                {{ opcion.precioTotalReserva }}{{ agenciaStore.getCurrency }}
                              </span>
                            </p>
                            <div class="w-100 text-end">
                              <button
                                class="boton boton-naranja fw-bold ms-0"
                                @click="saveCombinacion(opcion, lugarExperiencia)">
                                {{ $t('general.reservar') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end align-content-center mt-2 mb-1 me-2 gap-3">
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] > 2
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, false)">
                          {{ $t('general.mostrarMenos') }}
                        </div>
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] < opciones?.length
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, true)">
                          {{ $t('general.mostrarMas') }}
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
                <h6
                  v-if="
                    Object.keys(lugaresExperiencia).filter(e => {
                      return e != estacionSeleccionadaBuscador;
                    })?.length > 0
                  "
                  class="fs-4and5 fw-bold my-4 mb-3">
                  {{ $t('alojamiento.otrasOpcionesViaje') }}
                </h6>
                <template v-for="(opciones, lugarExperiencia) in lugaresExperiencia" :key="lugarExperiencia">
                  <div
                    v-if="estacionSeleccionadaBuscador != lugarExperiencia"
                    class="d-flex flex-column cuadro-forfaits my-3 p-2 p-md-4">
                    <div class="d-flex flex-column flex-md-row w-100 justify-content-between mb-3">
                      <div class="d-flex gap-2">
                        <div>
                          <img
                            class="img-estacion"
                            :src="
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].imagen
                                : ''
                            "
                            alt="" />
                        </div>

                        <div class="texto-estacion">
                          <p class="mb-0 fw-bold">
                            {{
                              estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                                ? estacionesData[lugarExperiencia].nombre
                                : ''
                            }}
                          </p>
                          <div
                            v-if="hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]"
                            class="d-flex align-items-start gap-1 ms-0">
                            <img class="icono-distancia-estacion" src="@/assets/icons/icono-telesilla.webp" />
                            <span class="texto-distancia-estacion">
                              a
                              {{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .distanciaKM >= 1
                                  ? hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM + ' km'
                                  : hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                      .distanciaKM *
                                      1000 +
                                    ' m'
                              }}
                              {{ $t('alojamiento.deEstacionEsqui') }}({{
                                hotelSeleccionadoBuscador.distanciasPistas[opciones[0].lugarExperienciaCodigo]
                                  .nombreAccesoPista
                              }})
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="info-estacion">
                        {{
                          estacionesData != null && estacionesData[lugarExperiencia] !== undefined
                            ? estacionesData[lugarExperiencia].texto
                            : ''
                        }}
                      </div>
                      <template v-if="desplegarEstaciones[lugarExperiencia] !== undefined">
                        <i
                          v-if="desplegarEstaciones[lugarExperiencia]"
                          class="cursor-pointer ms-5 me-3 fs-3 fa-solid fa-angle-up d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                        <i
                          v-else
                          class="cursor-pointer ms-5 me-3 fs-3 fa-solid fa-angle-down d-flex justify-content-end"
                          @click="desplegarEstaciones[lugarExperiencia] = !desplegarEstaciones[lugarExperiencia]" />
                      </template>
                    </div>

                    <template
                      v-if="
                        desplegarEstaciones[lugarExperiencia] !== undefined &&
                        desplegarEstaciones[lugarExperiencia] &&
                        numOpcionesMostrar[lugarExperiencia] !== undefined
                      ">
                      <div
                        v-for="(opcion, indOpcion) in opciones.slice(0, numOpcionesMostrar[lugarExperiencia])"
                        :key="indOpcion"
                        class="d-flex flex-column flex-md-row cuadro-opcion my-2 justify-content-between p-4">
                        <div class="d-flex flex-column gap-4 informacion-habitaciones">
                          <template v-for="(habitacion, indHab) in opcion.combinacion" :key="indHab">
                            <p class="fw-bold mb-0">
                              {{ $t('general.habitacion') }}
                              {{ titleCase(habitacion.texto) }}
                            </p>
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                              <div class="ms-4 d-flex w-100">
                                <div v-for="i in habitacion.precios.personas.numAdultos" :key="i" class="personas">
                                  <img src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                <div
                                  v-for="i in habitacion.precios.personas.numNinios"
                                  :key="i"
                                  class="personas d-flex">
                                  <img class="personitas" src="~@/assets/icons/personita.svg" alt="" />
                                </div>
                                {{ formatMiembrosHabitacion(habitacion.precios.personas) }}
                              </div>
                              <div class="d-flex flex-column text-start text-md-end w-100">
                                <p v-if="habitacion.precios.personas.numAdultos > 0" class="m-0">
                                  {{ $t('general.personas.mayus.adulto') }}:
                                  <span class="fw-bold">
                                    {{ formatPrice(habitacion.precios.personas.precioAdulto)
                                    }}{{ agenciaStore.getCurrency }}
                                  </span>
                                </p>
                                <p v-for="(n, i) in habitacion.precios.personas.ninios" :key="i" class="m-0">
                                  {{ $t('general.personas.mayus.nino') }}
                                  {{ n.edad }}
                                  {{ $t('general.anios') }}:
                                  <span class="fw-bold">
                                    {{ formatPrice(n.precio) }}{{ agenciaStore.getCurrency }}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="d-flex flex-column align-items-end justify-content-between">
                          <div
                            v-if="opcion.tipoCancelacion == 'TOTAL'"
                            class="texto-cancelacion-total fw-bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.cancelacionGratis') }}
                          </div>
                          <div
                            v-else-if="opcion.tipoCancelacion == 'PARCIAL'"
                            class="texto-cancelacion-parcial fw-bold d-flex justify-content-end align-items-center gap-1 mt-1">
                            <i class="fa-solid fa-circle-info" />
                            {{ $t('alojamiento.parcialmenteReembolsable') }}
                          </div>
                          <div v-else />
                          <div class="d-flex flex-column justify-content-end gap-2 alignt-items-center">
                            <p class="d-flex align-items-center gap-2 texto-desde-precio m-0 justify-content-end">
                              {{ $t('subtitulo.total') }}:
                              <span class="fs-5 fw-bold">
                                {{ opcion.precioTotalReserva }}{{ agenciaStore.getCurrency }}
                              </span>
                            </p>
                            <div class="w-100 text-end">
                              <button
                                class="boton boton-naranja fw-bold ms-0"
                                @click="saveCombinacion(opcion, lugarExperiencia)">
                                {{ $t('general.reservar') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end align-content-center mt-2 mb-1 me-2 gap-3">
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] > 2
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, false)">
                          {{ $t('general.mostrarMenos') }}
                        </div>
                        <div
                          v-if="
                            numOpcionesMostrar[lugarExperiencia] !== undefined &&
                            numOpcionesMostrar[lugarExperiencia] < opciones?.length
                          "
                          class="boton-mostrar"
                          @click="mostrarOpciones(lugarExperiencia, true)">
                          {{ $t('general.mostrarMas') }}
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </template>
            </template>
          </div>
          <template v-if="informacionAlojamiento?.faqs?.length > 0">
            <p id="preguntas" class="fw-bolder mt-5 mb-0 fs-2">
              {{ $t('alojamiento.preguntasFrecuentes') }}
            </p>
            <div id="accordionFlushExample" class="accordion accordion-flush mt-2 mb-4">
              <div v-for="(ques, index) in informacionAlojamiento.faqs" :key="ques" class="accordion-item translate">
                <p :id="'#flush-heading' + index" class="accordion-header fs-2">
                  <button
                    class="accordion-button collapsed ms-0 ps-0"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#flush-collapse' + index"
                    aria-expanded="false"
                    :aria-controls="'flush-collapse' + index">
                    {{ ques.pregunta }}
                  </button>
                </p>
                <div
                  :id="'flush-collapse' + index"
                  class="accordion-collapse collapse"
                  :aria-labelledby="'#flush-heading' + index"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    {{ ques.respuesta }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

  <div
    id="mapaModalAlojamiento"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mapaModalAlojamientoLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="mapaModalAlojamientoLabel" class="modal-title">
            {{ $t('alojamiento.ubicacion') }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div class="modal-body">
          <GMapMap :center="position" :zoom="8" map-type-id="terrain" style="min-height: 60vh">
            <GMapMarker :position="position" :clickable="true" :draggable="false">
              <GMapInfoWindow
                :opened="true"
                :options="{
                  pixelOffset: {
                    width: 10,
                    height: 0,
                  },
                  maxWidth: 320,
                  maxHeight: 320,
                }">
                <div class="fw-bolder">
                  {{ informacionAlojamiento.nombre }}
                </div>
              </GMapInfoWindow>
            </GMapMarker>
          </GMapMap>
        </div>
      </div>
    </div>
  </div>

  <ModalBuscador v-if="fromBuscador" />

  <ModalSimple id-modal="modalBuscadorParaTi" aria-labelled-by="modalBuscadorLabel">
    <template #titulo>
      <div class="fw-bold texto-nuestros-viajes-modal">{{ $t('alojamiento.modales.buscador.titulo') }}</div>
    </template>
    <template #contenido>
      <BuscadorParaTi />
    </template>
  </ModalSimple>

  <ModalSimple id-modal="modalFiltro" aria-labelled-by="modalFiltroLabel">
    <template #titulo>
      <div class="fw-bold texto-nuestros-viajes-modal">{{ $t('alojamiento.modales.filtros.titulo') }}</div>
    </template>
    <template #contenido>
      <div class="filtros">
        <div class="d-flex justify-content-between align-items-center">
          <div class="cuadro-azul">{{ $t('alojamiento.modales.filtros.subtitulo') }}</div>
          <button class="boton boton-no-fondo p-1" @click="resetFiltros()">
            {{ $t('alojamiento.modales.filtros.reestablecer') }}
          </button>
        </div>
      </div>
    </template>
  </ModalSimple>
</template>

<script setup>
  import CarouselAlojamiento from '@/components/Carousel/CarouselAlojamiento.vue';
  import { ref, computed, watch, onBeforeMount } from 'vue';
  import { buscadorStore } from '@/store_pinia/buscador';
  import ModalFotos from '@/components/modales/viajesGrupo/ModalFotos.vue';
  import { titleCase, capitalizeFirstLetter } from '@/helpers/filters';
  import { formatDateWithWeekDay } from '@/helpers/dateUtiles';
  import { BuscadorServicios } from '@/router/RouterNames';
  import BuscadorParaTi from '@/components/buscadores/BuscadorParaTi.vue';
  import router from 'src/router';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import HeaderBuscadorParaTi from '@/components/header/headerBuscadorParaTi';
  import ModalSimple from '@/components/modales/ModalSimple.vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { usePageMeta } from '@/composables/usePageMeta';
  import HomeApiService from '@/services/api/skiandnight/HomeApiService';
  import { useRoute } from 'vue-router';
  import { checkDomain, DOMAINS } from '@/helpers/domainUtils';
  import { formatPrice } from '@/helpers/numberUtils';

  const route = useRoute();
  const loadingStore = useLoadingStore();
  const store_buscador = buscadorStore();
  const agenciaStore = agenciaStoreModule();
  const opcionesPension = store_buscador.opcionesPension;
  const estacionesData = ref({});
  const numOpcionesMostrar = ref({});
  const desplegarEstaciones = ref({});
  const fromBuscador = route.path.includes('buscador');

  const initializing = ref(true);
  const informacionAlojamiento = ref({});
  const { webPageSchema } = usePageMeta({
    title: computed(() => informacionAlojamiento.value?.tituloSeo),
    description: computed(() => informacionAlojamiento.value?.descripcionSeo),
    image: computed(() => informacionAlojamiento.value?.imagenPrincipal),
  });
  const mostrarMas = ref(false);
  const position = ref({});

  const filtrosBuscador = computed(() => store_buscador.filtrosBuscador);
  const estacionSeleccionadaBuscador = computed(() => store_buscador.estacionSeleccionada);
  const hotelSeleccionadoBuscador = computed(() => store_buscador.hotelSeleccionado);
  const fechasAlojamiento = computed(() => store_buscador.filtrosSeleccionadosBuscador.fechasAlojamiento);

  const formattedInfo = computed(() => {
    const infoText = informacionAlojamiento.value?.info || '';
    const truncatedText = !mostrarMas.value && infoText.length > 200 ? infoText.substring(0, 200) + '...' : infoText;

    return truncatedText.split('\n').join('<br>');
  });

  function toggleMostrarMas() {
    mostrarMas.value = !mostrarMas.value;
  }

  function updateOpcionesPensionActual(optKey) {
    store_buscador.hotelSeleccionado.currentPension = optKey;
  }

  function scrollToElement(element) {
    window.scrollTo({
      top: document.getElementById(element)?.offsetTop - document.getElementById('desktop-navbar')?.offsetHeight,
      left: 0,
      behavior: 'smooth',
    });
  }

  function formatMiembrosHabitacion(personas) {
    let textAdulto =
      personas.numAdultos == 0
        ? null
        : personas.numAdultos == 1
        ? `${personas.numAdultos} adulto`
        : `${personas.numAdultos} adultos`;

    let textNinio =
      personas.numNinios == 0
        ? null
        : personas.numNinios == 1
        ? `${personas.numNinios} niño`
        : `${personas.numNinios} niños`;

    return textAdulto && textNinio ? `${textAdulto} + ${textNinio}` : textAdulto ? textAdulto : textNinio;
  }

  function mostrarOpciones(lugarExperiencia, mas) {
    if (mas) numOpcionesMostrar.value[lugarExperiencia] += 2;
    else numOpcionesMostrar.value[lugarExperiencia] -= 2;
  }

  function saveCombinacion(combinacion, lugarExperiencia) {
    store_buscador.setCombinacion(combinacion);
    store_buscador.setEstacionOpcionSeleccionada(lugarExperiencia);
    router.push({ name: BuscadorServicios });
  }

  async function init() {
    try {
      loadingStore.show();
      informacionAlojamiento.value = await HomeApiService.getAlojamiento(route.params.idAlojamiento);
      position.value = {
        lat: informacionAlojamiento.value.latitud,
        lng: informacionAlojamiento.value.longitud,
      };

      if (fromBuscador) {
        setTimeout(() => {
          scrollToElement('ofertas');
        }, 200);
      }
    } catch (error) {
      console.error(error);
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  watch(
    filtrosBuscador,
    () => {
      let lugaresExperiencia = {};
      let opciones = {};
      let desplegar = {};

      if (filtrosBuscador.value != null) {
        filtrosBuscador.value.areas.forEach(ar => {
          ar.lugaresExperiencia.forEach(est => {
            lugaresExperiencia[est.id] = {
              imagen: est.icono,
              nombre: est.nombre,
              texto: est.descripcion,
            };

            opciones[est.id] = 2;

            desplegar[est.id] = est.id == estacionSeleccionadaBuscador.value;
          });
        });

        estacionesData.value = lugaresExperiencia;
        numOpcionesMostrar.value = opciones;
        desplegarEstaciones.value = desplegar;
      }

      return lugaresExperiencia;
    },
    { immediate: true }
  );

  onBeforeMount(async () => await init());
</script>

<style lang="scss" scoped>
  .botones-container {
    padding: 1rem;
    overflow-x: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .btn-primary {
    border-radius: var(--bs-border-radius-xl);
    margin-right: 10px;
  }

  h5,
  h4,
  h6 {
    color: rgba(var(--bs-primary-rgb), 0.75);
  }

  .alojamiento-container {
    max-width: 1440px;
    margin: auto;
  }

  .fs-4and5 {
    font-size: 1.15rem !important;
  }

  .fs-7 {
    font-size: 0.9rem !important;
  }

  .fs-8 {
    font-size: 0.8rem !important;
  }

  .icono-distancia-estacion {
    width: 20px;
    margin-right: 0.05rem;
  }

  .boton {
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 500;
    padding: 0.5rem 1.5rem;
    margin-left: 1rem;
    border-radius: var(--bs-border-radius-xxl);
    transition: all 0.2s ease;
    border: 0;
  }

  .boton-no-fondo {
    background-color: inherit;
    color: var(--bs-primary);
  }

  .boton-no-fondo:hover {
    text-decoration: underline;
  }

  .boton-no-fondo:active {
    color: #080a1d;
  }

  .boton-naranja {
    background-color: var(--bs-secondary);
    color: white;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    max-width: 110px;
  }

  @media screen and (max-width: 500px) {
    .boton-naranja {
      width: 100%;
    }
  }

  .boton-naranja:hover {
    transform: scale(1.1);
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
  }

  .boton-naranja:active {
    outline: 2px solid rgba(33, 36, 68, 0.5);
  }

  .boton-blanco {
    background-color: white;
    color: #080a1d;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    max-width: 110px;
    min-height: 54px;
  }

  .boton-blanco:hover {
    transform: scale(1.1);
  }

  .boton-blanco:active {
    outline: 2px solid rgba(33, 36, 68, 0.5);
  }

  .cuadro-forfaits {
    border-radius: var(--bs-border-radius-xxl);
    width: 100%;
    background-color: #f9f7f8;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
  }

  @media screen and (max-width: 767px) {
    .cuadro-forfaits {
      border-radius: var(--bs-border-radius-lg);
    }
  }

  .boton-cuadro-azul {
    border: solid 1.5px var(--bs-primary);
    border-radius: var(--bs-border-radius);
    color: var(--bs-primary);
    background-color: inherit;
    padding: 0.2rem 1.2rem;
    cursor: pointer;
    box-shadow: 1px -0.5px 2px 0 rgba(0, 0, 0, 0.4);
  }

  .boton-cuadro-azul-selected {
    background-color: var(--bs-primary);
    color: white;
  }

  .img-estacion {
    width: 30px;
  }

  .texto-estacion {
    padding-top: 0.2rem;
    padding-right: 2rem;
  }

  .info-estacion {
    color: #6f6e8e;
    font-weight: 600;
    font-size: 0.9rem;
  }

  .icono-distancia-estacion {
    width: 20px;
  }

  .texto-distancia-estacion {
    color: #0073a4;
    font-size: 0.85rem;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .cuadro-opcion {
    background-color: white;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    width: 100%;
    border-radius: var(--bs-border-radius-xxl);
  }

  @media screen and (max-width: 767px) {
    .cuadro-opcion {
      border-radius: var(--bs-border-radius-lg);
    }
  }

  .texto-desde-precio {
    font-size: 0.6rem;
  }

  .personas {
    margin-left: -13px;
  }

  .personitas {
    margin-top: 5.5px;
    margin-left: 2px;
    width: 1.1rem;
  }

  .texto-cancelacion-total {
    color: #16ab0c;
    font-size: 0.8rem;
  }

  .texto-cancelacion-parcial {
    font-size: 0.8rem;
  }

  .boton-mostrar {
    cursor: pointer;
  }

  .boton-mostrar:hover {
    text-decoration: underline;
  }

  .card-check {
    background-color: #f9f7f8;
    padding: 1.3rem 0.5rem;
    border-radius: var(--bs-border-radius-xl);
    box-shadow: 0 4px 2px -2px gray;
  }

  .blog_banner {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin: auto;
    min-height: 65vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-image: url('~@/assets/fotos/footer.webp');

    &-container {
      max-width: 1440px;
      margin: 0 auto;
    }

    &-buttons {
      margin-bottom: 4rem;
    }
  }

  .carousel-imagenes {
    margin-top: -150px;
  }

  div :deep(.gm-ui-hover-effect) {
    display: none !important;
  }

  @media screen and (max-width: 992px) {
    .text-container {
      display: flex;
      flex-direction: column;

      .left,
      .right {
        width: 100%;
      }
    }
  }

  .informacion-habitaciones {
    width: 50%;
  }

  @media screen and (max-width: 767px) {
    .informacion-habitaciones {
      width: 100%;
    }
  }

  .modal-dialog {
    max-width: 750px !important;
  }

  .fa-door-open {
    opacity: 0.75;
  }

  .icon-checkin {
    transform: scaleX(-1);
  }

  .filtro-buscador {
    position: -webkit-sticky;
    position: sticky;
    top: 70px;
    z-index: 100;
    font-size: 0.7rem;
  }

  .buscador-ocultar {
    border-radius: var(--bs-border-radius-xl);
  }

  @media only screen and (max-width: 989px) {
    .buscador-desktop {
      height: 0px;
      overflow: hidden;
    }
  }

  .filtro-buscador {
    position: -webkit-sticky;
    position: sticky;
    top: 70px;
    z-index: 100;
    font-size: 0.7rem;
  }

  .boton-no-fondo {
    background-color: inherit;
    color: var(--bs-primary);
  }

  .cuadro-azul {
    background-color: var(--bs-primary);
    color: white;
    padding: 0.5rem 1.4rem;
    font-size: 0.9rem;
    font-weight: 650;
    border-radius: var(--bs-border-radius) var(--bs-border-radius) 0 0;
    box-shadow: 2px -1px 5px 0 rgba(0, 0, 0, 0.5);
  }

  .icon-location {
    font-size: 0.8rem;
    color: red;
  }
</style>
